import { Component, OnInit, Input } from '@angular/core';
import { Customer } from '@app/core/services/customer-request/model/customer';

@Component({
    selector: 'app-customer-request-customer-name',
    templateUrl: './customer-request-customer-name.component.html',
    styleUrls: ['./customer-request-customer-name.component.css'],
    standalone: false
})
export class CustomerRequestCustomerNameComponent implements OnInit {

  @Input()
  customer: Customer;
  
  constructor() { }

  ngOnInit() {
  }

}
